import { DELIVERY_TEXT, DINE_IN_TEXT, ROOM_SERVICE_TEXT, TABLE_ORDERS_TEXT } from './text';

export const SERVICE_MODES = {
	DINE_IN: 'dineIn',
	HOME_DELIVERY: 'homeDelivery',
	ROOM_SERVICE: 'roomService',
};

export const DIGITAL_MENU_MODE = 'digitalMenu';

export const SERVICE_MODES_TEXT = {
	[SERVICE_MODES.DINE_IN]: DINE_IN_TEXT,
	[SERVICE_MODES.HOME_DELIVERY]: DELIVERY_TEXT,
	[SERVICE_MODES.ROOM_SERVICE]: ROOM_SERVICE_TEXT,
};

export const PAYMENT_STATUS = {
	PENDING: 'PENDING',
	COMPLETED: 'COMPLETED',
	FAILED: 'FAILED',
	CANCELLED: 'CANCELLED',
};

export const ORDER_ACTIONS = {
	APPROVE_ORDER: 'APPROVE_ORDER',
	REJECT_ORDER: 'REJECT_ORDER',
	MARK_PAID: 'MARK_PAID',
	EDIT_ORDER: 'EDIT_ORDER',
	EDIT_ORDER_ITEM: 'EDIT_ORDER_ITEM',
	MARK_SERVED: 'MARK_SERVED',
	CANCEL_ORDER: 'CANCEL_ORDER',
	FINALIZE_AND_SEND_BILL: 'FINALIZE_AND_SEND_BILL',
	MARK_COMPLETED: 'MARK_COMPLETED',
	MARK_OUT_FOR_DELIVERY: 'MARK_OUT_FOR_DELIVERY',
	MARK_SUDO_PAID: 'MARK_SUDO_PAID',
	SEND_INVOICE: 'SEND_INVOICE',
	TIME_ELAPSED: 'TIME_ELAPSED',
	MERGE_ALLOWED: 'MERGE_ALLOWED',
};

export const TIMER_FOR_CALLING_ORDERS_API = 5000;

export const NUMBER_OF_ITEMS_TO_SHOW = 2;

export const PAYMENT_MODES_TYPES = {
	BOTH: 'BOTH',
	CASH_ONLY: 'CASH_ONLY',
	ONLINE_ONLY: 'ONLINE_ONLY',
};

export const PAYMENT_MODES = [
	{
		title: 'Both Online & Cash',
		type: PAYMENT_MODES_TYPES.BOTH,
	},
	{
		title: 'Online Only',
		type: PAYMENT_MODES_TYPES.ONLINE_ONLY,
	},
	{
		title: 'Cash Only',
		type: PAYMENT_MODES_TYPES.CASH_ONLY,
	},
];

export const UPDATE_PAYMENT_CONFIG_KEYS = {
	DEFAULT_FEES: 'defaultFees',
	PAYMENT_MODES: 'paymentModes',
};

export const ORDER_MODAL_SOURCE = {
	ORDER_DETAILS: 'orderDetails',
	ORDER_EDIT: 'orderEdit',
};

export const SOURCE_OF_ACTION_POPUP = {
	ADD_ITEM: 'addItem',
	EDIT_ITEM: 'editItem',
};

export const CHARGE_TYPE = {
	PERCENTAGE: 'percentage',
	FLAT_CHARGE: 'absolute',
};

export const QUANTITY_ACTIONS = {
	INCREAMENT: 'increase',
	DECREAMENT: 'decrease',
};

export const SERVICE_MODES_TEXTS = {
	[SERVICE_MODES.HOME_DELIVERY]: DELIVERY_TEXT,
	[SERVICE_MODES.DINE_IN]: TABLE_ORDERS_TEXT,
	[SERVICE_MODES.ROOM_SERVICE]: ROOM_SERVICE_TEXT,
};
